<template lang="pug">
div
    BaseHeader(
        :titulo='$t("mensagens.gerenteTerritorial.labels.titulo")',
        :voltarPara='{ route: "ConfiguracaoGerentesTerritoriais" }'
    )
    .bloco-cadastro-fornecedores
        h3 {{ $t('mensagens.gerenteTerritorial.labels.dadosCadastrais') }}
        .form-cadastro-gerenteTerritorial
            .form-cadastro-fornecedor__row
                label.form-cadastro-fornecedor__row-label {{ $t('mensagens.gerenteTerritorial.labels.gerenteComercial') }}

                el-select.w-50(
                    v-model='gerenteTerritorial.nomeGerenteComercial',
                    :loading='loading.gerentesComerciais',
                    :placeholder='$t("mensagens.comuns.selecione")',
                    clearable,
                    filterable,
                    width='50%'
                )
                    el-option(
                        v-for='({ nome, id }, index) in gerenteComercial',
                        :key='nome + id',
                        :id='index',
                        :label='nome',
                        :value='id'
                    )
            .form-cadastro-fornecedor__row
                label.form-cadastro-fornecedor__row-label.obrigatorio {{ $t('mensagens.gerenteTerritorial.labels.idBunge') }}
                input.form-cadastro-fornecedor__row-input(
                    :placeholder='$t("mensagens.gerenteTerritorial.labels.descricaoId")',
                    v-model='gerenteTerritorial.idBunge'
                )
            .form-cadastro-fornecedor__row
                label.form-cadastro-fornecedor__row-label.obrigatorio {{ $t('mensagens.gerenteTerritorial.labels.nome') }}
                input.form-cadastro-fornecedor__row-input(
                    :placeholder='$t("mensagens.gerenteTerritorial.labels.descricao")',
                    v-model='gerenteTerritorial.nome'
                )
        .footer
            .footer__btn.voltar(@click='goToListagem')
                i.mdi.mdi-arrow-left
                span {{ $t('mensagens.gerenteTerritorial.labels.voltar') }}
            .footer__btn.salvar(@click='cadastrarFornecedor')
                span {{ $t('mensagens.gerenteTerritorial.labels.salvar') }}
                i.mdi.mdi-arrow-right
</template>

<script>
import BaseHeader from '@/components/BaseHeader.vue';
import ContratoOriginacaoService from '@/services/ContratoOriginacaoService';
import EventBus from '@/utils/eventBus';

export default {
    name: 'CadastroGerenteTerritorial',
    components: {
        BaseHeader
    },
    data() {
        return {
            gerenteTerritorial: {
                nomeGerenteComercial: '',
                idBunge: '',
                nome: ''
            },
            gerenteComercial: [],
            loading: {
                gerentesComerciais: true
            }
        };
    },
    mounted() {
        this.buscarGerentesRegionais();
    },
    methods: {
        async buscarGerentesRegionais() {
            this.loadingScreen(true);
            this.loading.gerentesComerciais = true;

            const { data } =
                await ContratoOriginacaoService.buscarGerentesComerciais();

            if (data.length > 0) {
                this.loading.gerentesComerciais = false;
                this.gerenteComercial = data;
            }
            this.loadingScreen(false);
        },
        goToListagem() {
            this.$router.push({ name: 'ConfiguracaoGerentesTerritoriais' });
        },
        async cadastrarFornecedor() {
            const inputValido = this.validaInput();
            if (inputValido) {
                try {
                    const payload = this.montarPayload();

                    await ContratoOriginacaoService.cadastrarGerenteTerritorial(
                        payload
                    );
                    this.$notify.success(
                        this.$t(
                            'mensagens.gerenteTerritorial.labels.registroCadastrado'
                        )
                    );
                    this.goToListagem();
                } catch (error) {}
            }
        },
        validaInput() {
            if (
                !this.gerenteTerritorial.nome ||
                this.gerenteTerritorial.nome.trim() === ''
            ) {
                this.$notify.error(
                    this.$t('mensagens.gerenteTerritorial.labels.nomeVazio')
                );
                return false;
            }

            if (
                !this.gerenteTerritorial.idBunge ||
                this.gerenteTerritorial.idBunge.trim() === ''
            ) {
                this.$notify.error(
                    this.$t('mensagens.gerenteTerritorial.labels.idBungeVazio')
                );
                return false;
            }

            return true;
        },
        montarPayload() {
            return {
                nome: this.gerenteTerritorial.nome,
                idBunge: this.gerenteTerritorial.idBunge,
                idGerenteComercial: this.gerenteTerritorial.nomeGerenteComercial
            };
        },
        loadingScreen(isLoading) {
            const options = {
                mostrarLoading: isLoading,
                lockMessage: this.$t('mensagens.sistema.carregando')
            };
            EventBus.$emit('emit-componente-carregando', options);
        }
    }
};
</script>

<style lang="scss">
.bloco-cadastro-fornecedores {
    margin: 20px;
}

.form-cadastro-gerenteTerritorial {
    margin-top: 10px;
    background-color: $white;
    padding: 15px;
    display: flex;
    flex-direction: column;
    gap: 20px;
    border-radius: $default-border-radius;
    @include default-box-shadow();
}

.form-cadastro-fornecedor__row {
    display: flex;
    flex-direction: column;
    gap: 3px;
}

.form-cadastro-fornecedor__row-label {
    color: $primary;
    font-weight: bold;
}

.obrigatorio::after {
    content: '* ';
    color: red;
    margin-left: 3px;
}

.form-cadastro-fornecedor__row-input {
    width: 50%;
    height: 40px;
    border-radius: $default-border-radius;
    border: 1px solid $default-border-color;
    outline: 0;
    padding: 0 15px;
}

.form-cadastro-fornecedor__row-input-area {
    display: flex;
    gap: 10px;
    align-items: center;
}

.form-cadastro-fornecedor__btn-remover-cpf-cnpj {
    width: 48px;
    height: 32px;
    background-color: $background-danger;
    color: $font-danger;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: $default-border-radius;
}

.form-cadastro-fornecedor__btn-add-cpf-cnpj {
    width: 210px;
    height: 40px;
    margin-top: 5px;
    background-color: $white;
    color: $primary;
    font-weight: bold;
    border: 1px solid $primary;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 3px;
    border-radius: $default-border-radius;
    cursor: pointer;

    i.el-icon-plus {
        font-weight: bold;
    }
}

.form-cadastro-fornecedor__btn-add-cpf-cnpj:hover {
    background-color: var(--primary);
    color: $white;
}

.footer {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
}

.footer__btn {
    width: 100px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 5px;
    border-radius: $default-border-radius;
    cursor: pointer;

    .mdi-arrow-left {
        color: var(--primary);
    }

    .mdi-arrow-right {
        color: $white;
    }
}

.salvar {
    background-color: var(--primary);
    color: $white;
}

.salvar:hover {
    background-color: var(--secondary);
}

.footer__btn.voltar {
    background-color: transparent;
    color: var(--primary);
    border: 1px solid var(--primary);
}

.footer__btn.voltar:hover {
    background-color: var(--primary);
    color: $white;

    .mdi-arrow-left {
        color: $white;
    }
}
</style>
